module.exports = __webpack_public_path__ + "static/media/dhs_logo_50_50.7cc79345.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/dhs_logo_50_50.PNG
// module id = 423
// module chunks = 0